'use strict';

import appModule from '../../app.module';

angular.module(appModule)
.controller('AdminBudgetGeneralController', ['$scope', '$http', '$timeout', 'Auth', 'BudgetApiService',
function($scope, $http, $timeout, Auth, BudgetApiService) {

  /* ── état ─────────────────────────────────────────────────── */
  $scope.isLoading    = false;
  $scope.saving       = false;
  $scope.showModal    = false;
  $scope.successMsg   = '';
  $scope.errorMsg     = '';

  $scope.jeuxDonnees  = [];
  $scope.typesDonnees = [];
  $scope.annees       = [2026, 2025, 2024, 2023, 2022, 2021, 2020];
  $scope.entries      = [];
  $scope.allEntries   = [];

  $scope.selectedJeu   = '';
  $scope.selectedType  = '';
  $scope.selectedAnnee = String(new Date().getFullYear());
  $scope.searchQuery   = '';

  $scope.currentPage  = 1;
  $scope.itemsPerPage = 15;
  $scope.totalPages   = 1;
  $scope.totalItems   = 0;

  $scope.editing      = {};

  /* ── tri ───────────────────────────────────────────────────── */
  $scope.sortCol = 'libelle';
  $scope.sortAsc = true;
  $scope.sortBy  = function(col) {
    if ($scope.sortCol === col) { $scope.sortAsc = !$scope.sortAsc; }
    else { $scope.sortCol = col; $scope.sortAsc = true; }
    paginate();
  };

  /* ── pagination ────────────────────────────────────────────── */
  function paginate() {
    var size  = parseInt($scope.itemsPerPage, 10) || 15;
    var q     = ($scope.searchQuery || '').toLowerCase().trim();
    var filtered = $scope.allEntries.filter(function(e) {
      return !q || (e.libelle || '').toLowerCase().indexOf(q) !== -1;
    });

    var col = $scope.sortCol, asc = $scope.sortAsc;
    filtered.sort(function(a, b) {
      var va = a[col], vb = b[col];
      if (typeof va === 'string') va = va.toLowerCase();
      if (typeof vb === 'string') vb = vb.toLowerCase();
      if (va == null) va = ''; if (vb == null) vb = '';
      return va < vb ? (asc ? -1 : 1) : va > vb ? (asc ? 1 : -1) : 0;
    });

    $scope.totalMontantAll = filtered.reduce(function(s, e){ return s + (parseFloat(e.montant)     || 0); }, 0);
    $scope.totalPctAll     = filtered.reduce(function(s, e){ return s + (parseFloat(e.pourcentage) || 0); }, 0);

    $scope.totalItems  = filtered.length;
    $scope.totalPages  = Math.ceil(filtered.length / size) || 1;
    if ($scope.currentPage > $scope.totalPages) { $scope.currentPage = 1; }
    var start = ($scope.currentPage - 1) * size;
    $scope.entries = filtered.slice(start, start + size);
  }

  $scope.applyFilters = function() { paginate(); };

  $scope.changePage = function(p) {
    if (p < 1 || p > $scope.totalPages) { return; }
    $scope.currentPage = p;
    paginate();
  };

  $scope.getPages = function() {
    var pages = [], n = $scope.totalPages, c = $scope.currentPage;
    if (n <= 7) {
      for (var i = 1; i <= n; i++) { pages.push(i); }
    } else {
      pages = c <= 4 ? [1,2,3,4,5] :
              c >= n-3 ? [n-4,n-3,n-2,n-1,n] :
              [c-2,c-1,c,c+1,c+2];
    }
    return pages;
  };

  /* ── chargement jeux de données via BudgetApiService ────────── */
  function loadJeuxDonnees() {
    BudgetApiService.getJeuxDonnees().then(function(r) {
      $scope.jeuxDonnees = r.data || [];
      if ($scope.jeuxDonnees.length > 0) {
        $scope.selectedJeu = $scope.jeuxDonnees[0].code;
        loadTypes($scope.selectedJeu);
      }
    });
  }

  /* ── chargement types via BudgetApiService ───────────────────── */
  function loadTypes(jeuCode) {
    $scope.typesDonnees  = [];
    $scope.selectedType  = '';
    BudgetApiService.getTypesDonnees(jeuCode).then(function(r) {
      $scope.typesDonnees = r.data || [];
      if ($scope.typesDonnees.length > 0) {
        $scope.selectedType = $scope.typesDonnees[0].code;
      }
      $scope.loadData();
    });
  }

  $scope.onJeuChange = function() {
    if ($scope.selectedJeu) {
      loadTypes($scope.selectedJeu);
    } else {
      $scope.typesDonnees = [];
      $scope.selectedType = '';
    }
    $scope.allEntries = [];
    paginate();
  };

  /* ── chargement des données ──────────────────────────────────── */
  $scope.loadData = function() {
    if (!$scope.selectedJeu || !$scope.selectedType || !$scope.selectedAnnee) {
      return;
    }
    $scope.isLoading = true;
    $scope.allEntries = [];
    paginate();

    var jeu   = $scope.selectedJeu;
    var type  = $scope.selectedType;
    var annee = $scope.selectedAnnee;

    var jeuLibelle  = ($scope.jeuxDonnees.find(function(j){ return j.code === jeu; })  || {}).libelle || jeu;
    var typeLibelle = ($scope.typesDonnees.find(function(t){ return t.code === type; }) || {}).libelle || type;

    $http.get('/api/budget/donnees/' + jeu + '/' + type + '/' + annee)
      .then(function(r) {
        var raw = r.data;
        if (raw && raw.content) { raw = raw.content; }
        if (!Array.isArray(raw)) { raw = raw ? [raw] : []; }
        $scope.allEntries = raw.map(function(e) {
          return angular.extend({}, e, {
            jeuDonneesCode:    jeu,
            jeuDonneesLibelle: jeuLibelle,
            typeDonneesCode:   type,
            typeDonneesLibelle: typeLibelle,
            annee:             annee
          });
        });
        var totalM = $scope.allEntries.reduce(function(s, e) { return s + (parseFloat(e.montant) || 0); }, 0);
        if (totalM > 0) {
          $scope.allEntries.forEach(function(e) {
            e.pourcentage = parseFloat(((parseFloat(e.montant) || 0) / totalM * 100).toFixed(2));
          });
        }
        paginate();
      })
      .catch(function() {
        $scope.allEntries = [];
        paginate();
        $scope.errorMsg = 'Impossible de charger les données pour cette sélection.';
        $timeout(function() { $scope.errorMsg = ''; }, 4000);
      })
      .finally(function() { $scope.isLoading = false; });
  };

  /* ── modal création / édition ───────────────────────────────── */
  $scope.openNew = function() {
    $scope.editing   = {
      annee:          $scope.selectedAnnee,
      jeuDonneesCode: $scope.selectedJeu,
      typeDonneesCode: $scope.selectedType
    };
    $scope.showModal = true;
    $scope.errorMsg  = '';
  };

  $scope.openEdit = function(entry) {
    $scope.editing   = angular.copy(entry);
    $scope.showModal = true;
    $scope.errorMsg  = '';
  };

  $scope.closeModal = function() {
    $scope.showModal = false;
    $scope.editing   = {};
    $scope.errorMsg  = '';
  };

  /* ── sauvegarde ─────────────────────────────────────────────── */
  $scope.save = function() {
    if (!$scope.editing.libelle || !$scope.editing.annee) {
      $scope.errorMsg = 'Le libellé et l\'année sont obligatoires.';
      return;
    }
    $scope.saving = true;
    var isNew   = !$scope.editing.id;
    var url     = '/api/budget/donnees';
    var request = isNew
      ? $http.post(url, $scope.editing)
      : $http.put(url + '/' + $scope.editing.id, $scope.editing);

    request.then(function() {
      $scope.successMsg = isNew ? 'Entrée créée avec succès.' : 'Entrée mise à jour.';
      $scope.closeModal();
      $scope.loadData();
      $timeout(function() { $scope.successMsg = ''; }, 3500);
    }).catch(function(r) {
      $scope.errorMsg = (r.data && r.data.message) || 'Une erreur est survenue lors de la sauvegarde.';
    }).finally(function() {
      $scope.saving = false;
    });
  };

  /* ── suppression ─────────────────────────────────────────────── */
  $scope.confirmDelete = null;

  $scope.askDelete = function(entry) { $scope.confirmDelete = entry; };
  $scope.cancelDelete = function()   { $scope.confirmDelete = null; };

  $scope.doDelete = function() {
    if (!$scope.confirmDelete) { return; }
    var id = $scope.confirmDelete.id;
    $scope.confirmDelete = null;
    $http.delete('/api/budget/donnees/' + id).then(function() {
      $scope.successMsg = 'Entrée supprimée.';
      $scope.loadData();
      $timeout(function() { $scope.successMsg = ''; }, 3500);
    }).catch(function() {
      $scope.errorMsg = 'Impossible de supprimer cette entrée.';
      $timeout(function() { $scope.errorMsg = ''; }, 4000);
    });
  };

  /* ── export ──────────────────────────────────────────────────── */
  $scope.showExportMenu = false;

  $scope.toggleExportMenu = function($event) {
    $event.stopPropagation();
    $scope.showExportMenu = !$scope.showExportMenu;
  };

  // Fermer le menu si clic ailleurs
  var _hideMenu = function() { $scope.$applyAsync(function() { $scope.showExportMenu = false; $scope.showColPicker = false; }); };
  document.addEventListener('click', _hideMenu);
  $scope.$on('$destroy', function() { document.removeEventListener('click', _hideMenu); });

  $scope.showColPicker = false;
  $scope.toggleColPicker = function($event) { $event.stopPropagation(); $scope.showColPicker = !$scope.showColPicker; $scope.showExportMenu = false; };
  $scope.col = { jeu: true, type: true, annee: true, montant: true, pct: true };
  function getBudgetColInfo() {
    var defs = [
      { key: 'libelle', label: 'Libellé',          always: true },
      { key: 'jeu',     label: 'Jeu de données' },
      { key: 'type',    label: 'Type'             },
      { key: 'annee',   label: 'Année'           },
      { key: 'montant', label: 'Montant (M FCFA)' },
      { key: 'pct',     label: 'Pourcentage (%)'  }
    ];
    return defs.filter(function(d){ return d.always || $scope.col[d.key]; });
  }

  function buildFilename(ext) {
    var parts = ['budget-general'];
    if ($scope.selectedJeu)   { parts.push($scope.selectedJeu); }
    if ($scope.selectedType)  { parts.push($scope.selectedType); }
    if ($scope.selectedAnnee) { parts.push($scope.selectedAnnee); }
    return parts.join('-') + '.' + ext;
  }

  function getExportRows() {
    return $scope.allEntries.map(function(e) {
      return {
        libelle:    e.libelle             || '',
        jeu:        e.jeuDonneesLibelle   || e.jeuDonneesCode   || '',
        type:       e.typeDonneesLibelle  || e.typeDonneesCode  || '',
        annee:      e.annee              || '',
        montant:    e.montant            != null ? e.montant    : '',
        pct:        e.pourcentage        != null ? e.pourcentage : ''
      };
    });
  }

  $scope.exportCSV = function() {
    $scope.showExportMenu = false;
    var visCols = getBudgetColInfo();
    var rows = getExportRows().map(function(r) {
      return visCols.map(function(d) {
        var v = r[d.key];
        if (d.key === 'montant') return String(v || '').replace('.', ',');
        if (d.key === 'pct')     return String(v || '').replace('.', ',');
        return '"' + String(v || '').replace(/"/g, '""') + '"';
      }).join(';');
    });
    var csv = '\uFEFF' + visCols.map(function(d){ return d.label; }).join(';') + '\n' + rows.join('\n');
    triggerDownload(new Blob([csv], { type: 'text/csv;charset=utf-8;' }), buildFilename('csv'));
  };

  $scope.exportExcel = function() {
    $scope.showExportMenu = false;
    var rows    = getExportRows();
    var visCols = getBudgetColInfo();
    var jeu     = ($scope.jeuxDonnees.find(function(j){ return j.code === $scope.selectedJeu;  }) || {}).libelle || $scope.selectedJeu  || '';
    var type    = ($scope.typesDonnees.find(function(t){ return t.code === $scope.selectedType; }) || {}).libelle || $scope.selectedType || '';
    var annee   = $scope.selectedAnnee || '';

    var headerBg  = '#1e3a5f';
    var headerFg  = '#ffffff';
    var titleBg   = '#0f2544';
    var evenBg    = '#f0f4fa';
    var oddBg     = '#ffffff';
    var borderClr = '#b0bec5';

    var cellBase  = 'border:1px solid ' + borderClr + ';padding:6px 10px;font-size:11pt;font-family:Calibri,Arial,sans-serif;vertical-align:middle;';
    var numStyle  = cellBase + 'text-align:right;mso-number-format:&quot;# ##0.00&quot;;';
    var pctStyle  = cellBase + 'text-align:right;';
    var colWidths = { libelle:'240pt', jeu:'140pt', type:'140pt', annee:'60pt', montant:'110pt', pct:'80pt' };

    var html = '<!DOCTYPE html><html xmlns:o="urn:schemas-microsoft-com:office:office" '
             + 'xmlns:x="urn:schemas-microsoft-com:office:excel">'
             + '<head><meta charset="utf-8"/>'
             + '<xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>'
             + '<x:Name>Budget G\u00e9n\u00e9ral</x:Name>'
             + '<x:WorksheetOptions><x:FreezePanes/><x:FrozenNoSplit/>'
             + '<x:SplitHorizontal>2</x:SplitHorizontal><x:TopRowBottomPane>2</x:TopRowBottomPane>'
             + '</x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml>'
             + '</head><body>';

    html += '<table style="border-collapse:collapse;width:100%">';

    html += '<colgroup>';
    visCols.forEach(function(d) { html += '<col style="width:' + colWidths[d.key] + '"/>'; });
    html += '</colgroup>';

    html += '<tr>'
          + '<td colspan="' + visCols.length + '" style="' + cellBase + 'background:' + titleBg + ';color:#ffffff;'
          + 'font-size:14pt;font-weight:bold;text-align:center;padding:12px;">'
          + 'Budget G\u00e9n\u00e9ral \u2014 ' + escHtml(jeu)
          + (type  ? ' / ' + escHtml(type)  : '')
          + (annee ? ' (' + escHtml(annee) + ')' : '')
          + '</td></tr>';

    var now = new Date();
    var dateStr = now.toLocaleDateString('fr-FR') + ' \u00e0 ' + now.toLocaleTimeString('fr-FR', {hour:'2-digit',minute:'2-digit'});
    html += '<tr>'
          + '<td colspan="' + visCols.length + '" style="' + cellBase + 'background:#e8edf5;color:#555;font-size:9pt;text-align:center;">'
          + 'Export\u00e9 le ' + dateStr + ' \u2014 ' + rows.length + ' entr\u00e9e(s)'
          + '</td></tr>';

    html += '<tr>';
    visCols.forEach(function(d) {
      var align = (d.key === 'montant' || d.key === 'pct') ? 'right' : 'left';
      html += '<th style="' + cellBase + 'background:' + headerBg + ';color:' + headerFg + ';'
            + 'font-weight:bold;font-size:11pt;text-align:' + align + ';">' + d.label + '</th>';
    });
    html += '</tr>';

    rows.forEach(function(r, idx) {
      var bg = (idx % 2 === 0) ? evenBg : oddBg;
      var rowStyle = cellBase + 'background:' + bg + ';';
      html += '<tr>';
      visCols.forEach(function(d) {
        if (d.key === 'montant') {
          html += '<td style="' + numStyle + 'background:' + bg + ';">' + r.montant + '</td>';
        } else if (d.key === 'pct') {
          html += '<td style="' + pctStyle + 'background:' + bg + ';">' + (parseFloat(r.pct) || 0).toFixed(2).replace('.', ',') + ' %</td>';
        } else if (d.key === 'annee') {
          html += '<td style="' + rowStyle + 'text-align:center;font-weight:600;">' + escHtml(r.annee) + '</td>';
        } else if (d.key === 'libelle') {
          html += '<td style="' + rowStyle + 'font-weight:500;">' + escHtml(r.libelle) + '</td>';
        } else {
          html += '<td style="' + rowStyle + 'color:#444;">' + escHtml(r[d.key]) + '</td>';
        }
      });
      html += '</tr>';
    });

    var totalMontant = rows.reduce(function(s, r) { return s + (parseFloat(r.montant) || 0); }, 0);
    var nLabel = visCols.filter(function(d){ return d.key !== 'montant' && d.key !== 'pct'; }).length;
    html += '<tr>';
    if (nLabel > 0) {
      html += '<td colspan="' + nLabel + '" style="' + cellBase + 'background:#dce6f1;font-weight:bold;text-align:right;">TOTAL</td>';
    }
    if ($scope.col.montant) {
      html += '<td style="' + numStyle + 'background:#dce6f1;font-weight:bold;">' + totalMontant.toFixed(2) + '</td>';
    }
    if ($scope.col.pct) {
      html += '<td style="' + pctStyle + 'background:#dce6f1;font-weight:bold;">100,00 %</td>';
    }
    html += '</tr>';

    html += '</table></body></html>';
    triggerDownload(new Blob(['\uFEFF' + html], { type: 'application/vnd.ms-excel;charset=utf-8;' }), buildFilename('xls'));
  };

  function escHtml(str) {
    return String(str).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;');
  }

  function triggerDownload(blob, filename) {
    var url = URL.createObjectURL(blob);
    var a   = document.createElement('a');
    a.href  = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    $timeout(function() { URL.revokeObjectURL(url); }, 500);
  }

  /* ── import Excel ────────────────────────────────────────────── */
  $scope.showImportModal  = false;
  $scope.importLoading    = false;
  $scope.importError      = '';
  $scope.importRows       = [];
  $scope.importPreview    = [];
  $scope.importJeu        = '';
  $scope.importType       = '';
  $scope.importAnnee      = '';
  $scope.importTypesDonnees = [];

  $scope.openImportModal = function() {
    $scope.showImportModal    = true;
    $scope.importError        = '';
    $scope.importRows         = [];
    $scope.importPreview      = [];
    $scope.importJeu          = $scope.selectedJeu   || '';
    $scope.importType         = $scope.selectedType  || '';
    $scope.importAnnee        = $scope.selectedAnnee || String(new Date().getFullYear());
    $scope.importTypesDonnees = $scope.typesDonnees.slice();
  };

  $scope.closeImportModal = function() {
    $scope.showImportModal = false;
    $scope.importRows      = [];
    $scope.importPreview   = [];
    $scope.importError     = '';
  };

  $scope.onImportJeuChange = function() {
    $scope.importTypesDonnees = [];
    $scope.importType = '';
    if (!$scope.importJeu) { return; }
    BudgetApiService.getTypesDonnees($scope.importJeu).then(function(r) {
      $scope.importTypesDonnees = r.data || [];
      if ($scope.importTypesDonnees.length > 0) {
        $scope.importType = $scope.importTypesDonnees[0].code;
      }
    });
  };

  $scope.onFileChange = function(files) {
    if (!files || files.length === 0) { return; }
    var reader = new FileReader();
    reader.onload = function(e) {
      $scope.$apply(function() {
        try {
          var data  = new Uint8Array(e.target.result);
          var wb    = XLSX.read(data, { type: 'array' });
          var sheet = wb.Sheets[wb.SheetNames[0]];
          var raw   = XLSX.utils.sheet_to_json(sheet, { defval: '' });
          $scope.importRows    = _parseImportRows(raw);
          $scope.importPreview = $scope.importRows.slice(0, 5);
          $scope.importError   = $scope.importRows.length === 0
            ? 'Aucune ligne valide détectée. Vérifiez que le fichier contient les colonnes Libellé et Montant.'
            : '';
        } catch(err) {
          $scope.importError   = 'Impossible de lire le fichier Excel.';
          $scope.importRows    = [];
          $scope.importPreview = [];
        }
      });
    };
    reader.readAsArrayBuffer(files[0]);
  };

  function _parseImportRows(rawRows) {
    var parsed = rawRows.map(function(r) {
      var keys = Object.keys(r);
      var lkeys = keys.map(function(k){ return k.toLowerCase().trim(); });
      var get = function(patterns) {
        for (var i = 0; i < patterns.length; i++) {
          var idx = lkeys.indexOf(patterns[i]);
          if (idx >= 0) { return String(r[keys[idx]] || '').trim(); }
        }
        return '';
      };
      var libelle = get(['libellé','libelle','label','désignation','designation','intitulé','intitule','nom']);
      var montant = parseFloat(get(['montant','amount','valeur','value']).replace(',', '.')) || 0;
      var pct     = parseFloat(get(['pourcentage','pct','%','percent','taux']).replace(',', '.')) || 0;
      var codeStr = get(['code','n°','numero','numéro']);
      var code    = codeStr ? (parseInt(codeStr, 10) || null) : null;
      return { libelle: libelle, montant: montant, pourcentage: pct, code: code };
    }).filter(function(r){ return r.libelle && r.montant > 0; });

    var total = parsed.reduce(function(s, r){ return s + r.montant; }, 0);
    if (total > 0) {
      parsed.forEach(function(r) {
        if (!r.pourcentage) {
          r.pourcentage = parseFloat((r.montant / total * 100).toFixed(2));
        }
      });
    }
    return parsed;
  }

  $scope.confirmImport = function() {
    if ($scope.importRows.length === 0) { $scope.importError = 'Aucune ligne valide à importer.'; return; }
    if (!$scope.importJeu || !$scope.importType || !$scope.importAnnee) {
      $scope.importError = 'Sélectionnez le jeu de données, le type et l\'année.';
      return;
    }
    $scope.importLoading = true;
    $scope.importError   = '';
    $http.post('/api/budget/donnees/bulk', {
      jeuDonneesCode: $scope.importJeu,
      typeCode:       $scope.importType,
      annee:          parseInt($scope.importAnnee, 10),
      donnees:        $scope.importRows
    }).then(function(r) {
      var n = (r.data && r.data.count) ? r.data.count : $scope.importRows.length;
      var prevJeu   = $scope.importJeu;
      var prevType  = $scope.importType;
      var prevAnnee = String($scope.importAnnee);
      $scope.closeImportModal();
      $scope.successMsg    = n + ' entrée(s) importée(s) avec succès.';
      $scope.selectedJeu   = prevJeu;
      $scope.selectedType  = prevType;
      $scope.selectedAnnee = prevAnnee;
      $scope.loadData();
      $timeout(function() { $scope.successMsg = ''; }, 4000);
    }).catch(function(r) {
      $scope.importError = (r.data && r.data.message) || 'Erreur lors de l\'importation.';
    }).finally(function() {
      $scope.importLoading = false;
    });
  };

  $scope.downloadTemplate = function($event) {
    $event.preventDefault();
    var ws = XLSX.utils.aoa_to_sheet([
      ['Libellé', 'Montant', 'Pourcentage', 'Code'],
      ['Recettes fiscales',   150.50, 35.2, 1],
      ['Recettes douanières',  80.00, 18.5, 2],
      ['Recettes non fiscales', 45.00, 10.4, 3]
    ]);
    var wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Budget');
    XLSX.writeFile(wb, 'modele-import-budget.xlsx');
  };

  /* ── initialisation ─────────────────────────────────────────── */
  Auth.identity().then(function(user) {
    $scope.user = user;
    loadJeuxDonnees();
  });

}]);
